<script>
import imageTransform from 'foundation/js/imageTransformation/imageTransform';
import { reportCard_4_5 } from 'foundation/js/imageTransformation/imagePresets';

export default {
    name: 'ReportCard',
    props: {
        data: {
            type:Object,
            required: true
        }
    },
    setup(){
        return { imageTransform, reportCard_4_5 }
    }
}
</script>

<template>
    <a :href="data.url" class="kb-report-card" draggable="true">
        <div v-if="data.imageUrl" class="kb-report-card__image">
            <img :src="imageTransform(data.imageUrl, reportCard_4_5)" :alt="data.imageAlt ?? ''" />
        </div>

        <h3 class="kb-report-card__title">{{ data.title }}</h3>
        <p class="kb-report-card__text">{{ data.summary }}</p>
    </a>
</template>
